import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map, skip, switchMap, take } from 'rxjs';

import { selectOrder } from '@b2b/features/order/core/store/order.states';
import { createOrder, getOrder, getOrderList } from '@b2b/features/order/core/store/order.actions';
import { CartService } from '@b2b/features/cart/core/cart.service';
import { LocalStorageService } from '@shared/tools/local-storage.service';
import { B2B_CUSTOMER_ID_KEY, B2B_UNIT_ID_KEY } from '@shared/tools/constants';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  constructor(
    private store: Store,
    private cartService: CartService,
    private localStorage: LocalStorageService,
  ) {}

  currentOrder = '';

  loadOrders(page = 1) {
    this.cartService
      .getCart()
      .pipe(
        filter(state => !state.isLoading && !!state.data),
        take(1),
        map(state => state.data!),
      )
      .subscribe(cart => {
        const b2bUnitUid = cart.b2BUnitCode || this.localStorage.getItem(B2B_UNIT_ID_KEY) || '';
        const customerUid = cart.customerId || this.localStorage.getItem(B2B_CUSTOMER_ID_KEY) || '';

        this.store.dispatch(
          getOrderList({
            b2bUnitUid,
            customerUid,
            page,
          }),
        );
      });
  }

  loadCurrentOrder() {
    this.store.dispatch(getOrder({ code: this.currentOrder }));
  }

  getCurrentOrder() {
    return this.store.select(selectOrder);
  }

  takeOrder() {
    return this.store.select(selectOrder).pipe(
      filter(state => !state.list.isPristine && !state.list.isLoading && !!state.list.data),
      map(state => state.list.data!),
    );
  }

  isLoadingOrders() {
    return this.store.select(selectOrder).pipe(map(state => !!state.list.isLoading));
  }

  getCurrentPage() {
    return this.store.select(selectOrder).pipe(map(state => state.currentPage));
  }

  getTotalPages() {
    return this.store.select(selectOrder).pipe(map(state => state.totalPages));
  }

  createOrder() {
    this.store.dispatch(createOrder());
    return this.store.select(selectOrder).pipe(skip(1));
  }
}
